




































































































































import { Vue, Component, Prop, Watch } from "vue-property-decorator";
import { Tab, Tabs, ActionSheet, Search, Checkbox, CheckboxGroup, Cell, CellGroup, Field } from "vant";
import trafficPolicyService from "@/service/trafficPolicyService";
declare let AMap: any;
import * as _ from "lodash";
import { ContactInfoEntity, RoleInfoEntity } from "@/model/system";
import { BtripTextEntity, ProjectEntity } from "@/model/Btrip";
import dataShare from "../dataShare";
import UserService from "@/service/UserService";
import btripServcice from "@/service/btripServcice";
import { ApplyArea, ServiceType, TravelReasonType, RoleType, CreateMode, BookingType, BusinessType, PriceType, VoyageType, ScreeningRulesType } from "@/model/Base";
import trafficService from "@/service/trafficService";
import chargePolicyService from "@/service/chargePolicyService";

@Component({
  name: "taxiList",
  components: {
    [Tabs.name]: Tabs,
    [ActionSheet.name]: ActionSheet,
    [Search.name]: Search,
    [Checkbox.name]: Checkbox,
    [CheckboxGroup.name]: CheckboxGroup,
    [Cell.name]: Cell,
    [CellGroup.name]: CellGroup,
    [Tab.name]: Tab,
    [Field.name]: Field,
  },
})
export default class taxiList extends Vue {
  result = [];
  get departData(): any {
    return JSON.parse((this as any).$route.query.departAddress);
  }
  get arriveData(): any {
    return JSON.parse((this as any).$route.query.arriveAddress);
  }
  get departDate(): any {
    return this.$route.query.departureTime;
  }
  get departureTime(): any {
    if (this.departDate) {
      return (this as any).$moment(this.departDate).format("MM月DD日 HH:mm");
    }
    return "现在出发";
  }
  get serviceScene(): any {
    return this.$route.query.scene;
  }

  isEditPersaon = false;

  contact: ContactInfoEntity = {};
  contacts: ContactInfoEntity[] = [];
  loadContacts() {
    let __self = this;
    UserService.getContactList({ RoleID: __self.profile.UserID }).then(json => {
      if (!json.isSucc) {
        return;
      }
      let contacts = json.result!.entities!;
      let contact = contacts[0];
      for (let i = 0; i < contacts.length; i++) {
        let current = contacts[i];
        if (contact.ContactName && contact.ContactPhone) {
          contact = current;
          break;
        }
      }

      __self.contact = JSON.parse(JSON.stringify(contact));
      __self.contacts = contacts;
    });
  }
  saveContact() {
    let __self = this;
    let contact = __self.contact;
    let maxScore = 0;
    if (contact.ContactName) {
      maxScore++;
    }
    if (contact.ContactPhone) {
      maxScore++;
    }
    if (contact.ContactEmail) {
      maxScore++;
    }
    __self.contacts.forEach((o: any) => {
      let score = 0;
      if (o.ContactPhone == contact.ContactPhone && contact.ContactPhone) score++;
      if (o.ContactName == contact.ContactName && contact.ContactName) score++;
      if (o.ContactEmail == contact.ContactEmail && contact.ContactEmail) score++;
      o.score = score;
    });
    let contacts = _.sortBy(__self.contacts, (o: any) => o.score).reverse();
    if (contacts && contacts[0]) {
      let model = contacts[0] as any;
      if (model.score == maxScore) {
        return;
      }
    }
    let model = contacts[0];
    let originContact = contacts.find(o => o.ContactID == contact.ContactID) as any;
    if (originContact.score == 0 || originContact.score == (contacts[0] as any).score) {
      model = contact;
    } else {
      if (contact.ContactName) {
        model.ContactName = contact.ContactName;
      }
      if (contact.ContactPhone) {
        model.ContactPhone = contact.ContactPhone;
      }
      if (contact.ContactEmail) {
        model.ContactEmail = contact.ContactEmail;
      }
    }
    UserService.saveContactInfo(model).then(response => console.log(response.message));
  }

  mounted() {
    this.loadContacts();
    this.getProductLists();
    this.BtripInit();
    let depLatLgt = {
      longitude: this.departData.longitude * 1,
      latitude: this.departData.latitude * 1,
    };
    let arrLatLgt = {
      longitude: this.arriveData.longitude * 1,
      latitude: this.arriveData.latitude * 1,
    };
    (this as any).$refs.mapContainer.planning(depLatLgt, arrLatLgt);
  }

  productLists: any = [];
  getProductLists() {
    let data = {
      DepartLongitude: this.departData.longitude,
      DepartLatitude: this.departData.latitude,
      ArriveLongitude: this.arriveData.longitude,
      ArriveLatitude: this.arriveData.latitude,
      DepartZoneId: this.departData.cityId + "",
      ArriveZoneId: this.arriveData.cityId + "",
      DepartAddress: this.departData.detail,
      ArriveAddress: this.arriveData.detail,
      UseTime: this.departDate,
      ServiceSecne: this.serviceScene,
    };
    trafficPolicyService.getProductList(data).then((res: any) => {
      if (res.isSucc) {
        _.forEach(res.result, item => {
          _.forEach(item.PriceList, el => {
            this.$set(el, "VehicleId", item.VehicleId);
            this.$set(el, "VehicleName", item.VehicleName);
            this.$set(el, "ProductId", item.ProductId);
          });
        });
        this.productLists = res.result;
      }
    });
  }
  isContrary(goods: any) {
    return goods && goods.Contrarys && goods.Contrarys.length > 0;
  }
  contraryTips(goods: any) {
    let contrarys: string[] = [];
    if (goods && goods.Contrarys) {
      [].push.apply(contrarys, goods.Contrarys);
    }

    return _.uniq(contrarys).join(",");
  }
  showContraryTips(goods: any) {
    this.$root.$toast((this.$root.$t("mall_flight_flightdetails_weibei") as string) + this.contraryTips(goods));
  }

  getNum(value: any) {
    let chekedArr = _.filter(this.result, (item: any) => item.VehicleId == value.VehicleId);
    return chekedArr.length > 0 ? chekedArr.length : false;
  }

  toggle(price: any) {
    _.forEach((this as any).$refs.checkboxes, item => {
      if (item.name.SupplierName == price.SupplierName && item.name.VehicleId == price.VehicleId && item.name.Amount == price.Amount) {
        item.toggle();
      }
    });
  }

  isShowTourismInfo = false;
  approvalOfCar() {
    if (!this.contact.ContactPhone) {
      return this.$toast.fail("请填写乘车人联系方式");
    }
    this.loadContrarys();
    // this.loadCharges();
    this.isShowTourismInfo = true;
  }
  getBtnText() {
    let arr = _.sortedUniq(_.map(this.result, (item: any) => item.VehicleName));
    if (arr.length > 1) {
      return `同时呼叫 ${arr.join(" + ").replace(/型/gi, "")}`;
    }
    return "立即用车";
  }
  defaultPrice() {
    let prices = [];
    try {
      for (let i = 0; i < this.productLists.length; i++) {
        const product = this.productLists[i];
        let minPrice = _.minBy(product.PriceList, (p: any) => p.Amount);
        prices.push(minPrice);
      }
    } catch {}

    return _.minBy(prices, (p: any) => p.Amount);
  }
  get isEmptyData() {
    for (let i = 0; i < this.productLists.length; i++) {
      const product = this.productLists[i];
      if (this.canShowProduct(product)) {
        return false;
      }
    }
    return true;
  }
  canShowProduct(product: any) {
    for (let i = 0; i < product.PriceList.length; i++) {
      if (this.canShowPrice(product.PriceList[i])) {
        return true;
      }
    }
    return false;
  }

  canShowPrice(price: any) {
    if (this.isHideOverproof && this.isContrary(price) && this.defaultPrice().Amount != price.Amount) {
      return false;
    }
    return true;
  }

  get FeatureCodes() {
    return this.$route.query.FeatureCodes || "";
  }
  get isHideOverproof() {
    return this.FeatureCodes.indexOf("HideProduct") > -1;
  }

  back() {
    history.back();
  }

  dataShare = dataShare;
  get RuleID() {
    return this.$route.query.RuleID;
  }
  get employees(): { ConsumerID: string; ConsumerName: string }[] {
    return [{ ConsumerID: this.profile.UserID as string, ConsumerName: this.profile.UserName as string }];
  }
  ProjectID = "";
  CenterID = "";
  ApprovalRule = "";

  get isShowApprovalNo() {
    return this.checkRule(ScreeningRulesType.ApprovalNoRequire) || this.checkRule(ScreeningRulesType.ApprovalDisplayOnly);
  }

  checkRule(RuleID: number) {
    return this.ApprovalRule && this.ApprovalRule.indexOf(RuleID + "") > -1;
  }
  get isMustApproval() {
    return this.checkRule(ScreeningRulesType.OnlineBookingApproval);
  }

  BtripInit() {
    let __self = this;
    let datas: any = { RuleID: __self.RuleID };
    if (!datas.RuleID) {
      datas.CompanyID = __self.profile.CompanyID;
      datas.ApplyArea = __self.model.ApplyArea;
      datas.ServiceType = __self.model.ServiceType;
      datas.Users = this.employees.map((o: any) => o.ConsumerID);
    }
    btripServcice.getTripRule(datas).then(json => {
      if (json.isSucc && json.result) {
        let result = json.result;
        __self.ApprovalRule = result.ApprovalRule!;

        let data = _.find(__self.dataShare.costCenters, (o: any) => o.RoleID == result.CostCenter);
        if (data) {
          __self.costCenter = data;
        }
        // __self.tripFlow = result.TripFlow;
        __self.ProjectID = result.ProjectCode!;
        __self.CenterID = result.CostCenter!;
        this.loadTripIntent();
        this.loadCostCenter();
        this.loadProjectCode();
      }
    });
  }
  //成本中心
  loadCostCenter() {
    let RootID = this.profile.CompanyID;
    const data = { PageSize: 999999, Superior: { RoleType: 1319, RootID: RootID }, RoleType: 1319 };
    UserService.getRoleList(data).then(res => {
      if (res.isSucc) {
        let costCenters = res.result!.entities! as any;
        this.dataShare.costCenters = _.orderBy(costCenters, ["UpdateTime"], ["desc"]) as any;
      }
    });
  }

  //项目代码
  loadProjectCode() {
    let __self = this;
    btripServcice.getProjectList({ OwnerID: this.profile.CompanyID, PageSize: 999 } as any).then(json => {
      if (json.isSucc) {
        let projectCodes = json.result!.entities!;
        let project = _.find(projectCodes, o => o.ProjectID == __self.ProjectID);

        let ProjectID = __self.ProjectID;
        if (project) {
          __self.projectCode = project;
        } else {
          __self.projectCode = {
            ProjectCode: ProjectID,
            ProjectID: ProjectID,
          };
        }
        this.dataShare.projectCodes = projectCodes as any;
      }
    });
  }

  //差旅目的
  loadTripIntent() {
    let __self = this;
    const data = this.model.ServiceType.toString();
    btripServcice.getBtripTexts(data).then(json => {
      if (json.isSucc) {
        let tripIntents = [];
        let contraryReasons = [];
        for (let j = 0; j < json.result!.length; j++) {
          var element = json.result![j];
          if (element.TextType == TravelReasonType.TravelPurpose) {
            tripIntents.push(element);
          }
          if (element.TextType == TravelReasonType.PolicyCause) {
            contraryReasons.push(element);
          }
        }

        this.dataShare.tripIntents = tripIntents as any;
        this.dataShare.contraryReasons = contraryReasons as any;

        if (tripIntents.length > 0) {
          __self.tripIntent = tripIntents[0];
        }
      }
    });
  }

  loadContrarys() {
    let __self = this;
    __self.model.Contrarys = [];
    for (let i = 0; i < __self.result.length; i++) {
      const goods = __self.result[i] as any;
      // let contrarys: string[] = [];
      if (!goods || !goods.Contrarys || goods.Contrarys.length == 0) {
        continue;
      }
      let features = goods.Contrarys;
      if (features.length <= 0) {
        continue;
      }

      // this.$set(el, "VehicleId", item.VehicleId);
      // this.$set(el, "VehicleName", item.VehicleName);

      let cause = {
        ContraryInfo: features.join(","),
        ProductID: goods.VehicleId,
        ProductName: goods.VehicleName,
        CauseID: "",
        CauseDetails: "",
        CauseName: "",
      } as any;
      let Contrarys = __self.model.Contrarys as any[];
      Contrarys.push(cause);
      // }
    }
  }

  get reviseTripIntent() {
    let __self = this;
    if (this.tripIntent.FeatureCode && this.tripIntent.FeatureCode.indexOf("invisible") > -1 && this.ApprovalRule && this.ApprovalRule.indexOf("1580") > -1) {
      return true;
    }

    return false;
  }
  get CostCenters() {
    return this.dataShare.costCenters as RoleInfoEntity[];
  }
  get costCenter(): RoleInfoEntity {
    return this.dataShare.costCenter;
  }
  set costCenter(value) {
    this.dataShare.costCenter = value;
  }
  chooseCostCenter() {
    this.$router.push("/mall/chooseCostCenter");
  }

  get tripIntent(): BtripTextEntity {
    return this.dataShare.tripIntent;
  }
  set tripIntent(value) {
    this.dataShare.tripIntent = value;
  }
  chooseTripIntent() {
    this.$router.push("/mall/chooseTripIntent");
  }

  get projectCode(): ProjectEntity {
    return this.dataShare.projectCode;
  }
  set projectCode(value) {
    this.dataShare.projectCode = value;
  }
  chooseProjectCode() {
    this.$router.push("/mall/chooseProjectCode");
  }

  get contraryReason(): BtripTextEntity {
    return this.dataShare.contraryReason;
  }
  set contraryReason(value) {
    this.dataShare.contraryReason = value;
  }

  // chooseIndex = 0;
  chooseContraryReason(contrary: any, index: number) {
    this.contraryReason = contrary;
    this.$router.push("/mall/chooseContraryReason");
  }

  model: any = {
    CreateMode: CreateMode.APP,
    ProductID: "",
    // VoyageType: "",
    BookingType: BookingType.OnBusiness,
    ApplyArea: ApplyArea.Internal,
    ServiceType: ServiceType.TrafficService,
    CenterID: "",
    IntentID: "",
    IntentName: "",
    ProjectCode: "",
    ContactName: "",
    ContactPhone: "",
    ContactEmail: "",
    // ContactEmailNotify: true,
    // TicketDelivery: 1450,
    Remark: "",
    Contrarys: [],
    // Consumers: [],
    // MailingAddress: { AddressID: "", Recipient: "", Address: "", Sex: "", ContactPhone: "", EmsCode: "" },
    // Extras: [
    //   // { ServiceType: 1466, ThrowID: "" },
    //   { ServiceType: 1410, ThrowID: "" },
    // ],
    // ShoppingID: "",
    ClientUniqueID: "",
  };
  CreateOrder() {
    let __self = this;
    if (this.result.length == 0) {
      return this.$root.$toast.fail("请选择车型");
    }

    this.model.CenterID = this.costCenter.RoleID!;
    this.model.IntentID = this.tripIntent.TextID!;
    this.model.ProjectCode = this.projectCode.ProjectCode!;

    let model = this.model;
    let approvalRule = this.ApprovalRule;

    if (approvalRule && approvalRule.indexOf("1543") > -1 && !model.CenterID && this.CostCenters && this.CostCenters.length > 0) {
      return this.$root.$toast.fail(this.$root.$t("mall_order_qingxuanzechengbenzhongxin") as string);
    }
    if (approvalRule && approvalRule.indexOf("1544") > -1 && !model.ProjectCode) {
      return this.$root.$toast.fail(this.$root.$t("mall_order_qingtianxiexiangmudaima") as string);
    }
    if (approvalRule && approvalRule.indexOf("1582") > -1 && !model.ClientUniqueID) {
      return this.$root.$toast.fail(this.$root.$t("mall_order_qingtianxieshenpidanhao") as string);
    }

    if (approvalRule && approvalRule.indexOf("1580") > -1) {
      if (!model.IntentID) {
        return this.$root.$toast.fail(this.$root.$t("mall_order_qingtianxiechalvmude") as string);
      }
      let FeatureCode = this.tripIntent && (this.tripIntent.FeatureCode as string);
      if (model.IntentName == "" && FeatureCode && FeatureCode.indexOf("invisible") > -1) {
        return this.$root.$toast.fail(this.$root.$t("mall_order_qingtianxiexiangqingmude") as string);
      }
    }

    for (let i = 0; i < model.Contrarys.length; i++) {
      let contrary = model.Contrarys[i] as any;
      let FeatureCode = contrary.FeatureCode;
      let CauseID = contrary.CauseID;
      if (approvalRule && approvalRule.indexOf("1540") > -1 && CauseID == "") {
        return this.$root.$toast.fail(this.$root.$t("mall_order_qingxuanzeweibeiyuanyin") as string);
      }
      if (approvalRule && approvalRule.indexOf("1540") > -1 && FeatureCode.indexOf("invisible") > -1 && contrary.CauseDetails == "") {
        return this.$root.$toast.fail(this.$root.$t("mall_order_qingtianxieweibeixiangqingyuanyin") as string);
      }
    }
    let data = this.model;

    data.ConsumerDate = this.departDate;
    data.ConsumerLongitude = this.departData.longitude;
    data.ConsumerLatitude = this.departData.latitude;
    data.FinishedLongitude = this.arriveData.longitude;
    data.FinishedLatitude = this.arriveData.latitude;
    data.ConsumerZoneId = this.departData.cityId + "";
    data.FinishedZoneId = this.arriveData.cityId + "";
    data.ConsumerAddress = this.departData.detail;
    data.FinishedAddress = this.arriveData.detail;
    data.ContactPhone = this.contact.ContactPhone;
    data.ContactName = this.contact.ContactName;
    data.ContactEmail = this.contact.ContactEmail;
    data.ProductID = "";
    data.PriceMarks = "";
    data.PriceMarks = _.map(this.result, (item: any) => item.PriceMark).join(",");
    data.ProductID = _.sortedUniq(_.map(this.result, (item: any) => item.ProductId)).join(",");

    trafficService.CreateOrder(data).then((res: any) => {
      if (!res.isSucc) {
        __self.$toast(res.message);
        return;
      }
      let orderId = res.result.split("-")[0];
      __self.saveContact();
      __self.$router.push({
        path: "/order/details",
        query: { OrderID: orderId, ServeType: "1555" },
      });
    });
  }

  //服务费
  charge: any = {
    Goods: [
      {
        Prices: [
          {
            // ClientPriceID: null,
            // FeatureCode: null,
            // GoodsID: null,
            // GroupCode: null,
            MarketPrice: 0,
            // OrderID: null,
            // OriginID: null,
            // PriceCode: null,
            // PriceID: null,
            // PriceName: null,
            PriceType: PriceType.TicketFare,
            // ProductID: null,
            SalesPrice: 0,
            // SourceID: null,
            // StandardPrice: null,
            SupplyPrice: 0,
            // SupplyPriceID: null,
            // UniqueID: null,
          },
        ],
      },
    ],
  };
  // loadCharges() {
  //   let __self = this;
  //   let data: any = {};
  //   data.ServiceType = ServiceType.TrafficService;
  //   data.BusinessType = BusinessType.Sales;
  //   data.ApplyArea = ApplyArea.Internal;
  //   data.VoyageType = VoyageType.SingleVoyage;
  //   data.BookingType = BookingType.OnBusiness;

  //   data.ProductID = _.sortedUniq(_.map(this.result, (item: any) => item.ProductId)).join(",");
  //   data.ConsumerCount = 1;
  //   data.ProduceID = "";

  //   chargePolicyService.getProductInfo(data, { failTips: false }).then(json => {
  //     if (json.isSucc && json.result && json.result.length > 0) {
  //       let result = json.result as any;
  //       this.charge = result[0];
  //     }
  //   });
  // }
  // get chargePrice() {
  //   let __self = this;
  //   if (!__self.charge) {
  //     return 0;
  //   }
  //   return __self.charge.Goods[0].Prices[0].SalesPrice;
  // }
}
